import React, { useRef } from "react";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";

const CustomTextField = ({ type='text', label, value, onChange, endIcon, startIcon, sx, InputProps, ...props }) => {
  const inputRef = useRef(null);
  const preventWheel = (e) => e.preventDefault();
  const handleChange = (event) => {
    const raw = event.target.value;
    onChange(raw);
  };

  const handleFocus = (event) => {
    event.target.addEventListener("wheel", preventWheel, { passive: false });
  };

  const handleBlur = (event) => {
    event.target.removeEventListener("wheel", preventWheel);
  };

  return (
    <TextField
      label={label}
      value={value}
      inputRef={inputRef}
      onChange={handleChange}
      type={type}
      onFocus={handleFocus}
      onBlur={handleBlur}
      InputProps={{
        ...InputProps,
        sx: {
              borderRadius: "10px",
              backgroundColor: "background.paper",
              px: { xs: 1, md: 1.3 },
              py: { xs:0, md: 0.5 },
            },
            startAdornment: startIcon ? (
              <InputAdornment position="start">
                {startIcon}
              </InputAdornment>
            ) : null,
            endAdornment: endIcon ? (
              <InputAdornment position="end">
                {endIcon}
              </InputAdornment>
            ) : null,
      }}
      sx={{
        "& input::placeholder": {
          color: "text.secondary",
          opacity: 1,
        },
        "& .MuiOutlinedInput-root": {
          fontSize: { xs: "1.1rem", md: "1rem" },
          "& fieldset": {
            borderColor: "divider",
          },
          "&:hover fieldset": {
            borderColor: "#5E17EB",
            borderWidth: 2,
          },
          "&.Mui-focused fieldset": {
            borderWidth: 2,
            borderColor: "#5E17EB",
          },
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default CustomTextField;
